import Vue from 'vue';
import UIKit from '@uikit/ui-kit';
import { ObserveVisibility } from 'vue-observe-visibility';

import '@uikit/ui-kit/lib/ui-kit.min.css';

import '@/assets/styles/app.scss';

Vue.use(UIKit);
Vue.directive('observe-visibility', ObserveVisibility);
